// @ts-check
import React, { Component, Fragment } from "react"
import { createPortal } from "react-dom"
import { BlockContextConsumer } from "./ContextProviders"
import AvailableActions from "./actions/AvailableActions"
import DisplayBroadcast from "./broadcast/DisplayBroadcast"
import AvailableProperties from "./properties/AvailableProperties"
import AvailableValidations from "./validation/AvailableValidations"
// import LagRadar from "_archive/utils/LagRadar"

class BlockDebugPortal extends Component {
    render() {
        const children = (
            <BlockContextConsumer>
                {context =>
                    context.block && (
                        <div onClick={event => event.stopPropagation()}>
                            <b>Attributes</b>
                            <br />
                            <pre>{JSON.stringify(context.block.config.attributes, null, 4)}</pre>
                            <div className="sidebar-divider" />
                            <AvailableProperties>
                                {properties => (
                                    <Fragment>
                                        List of Available Properties: ({properties.length})
                                        <br />
                                        <ul>
                                            {properties.map(property => (
                                                <li>
                                                    <DisplayBroadcast broadcast={property} />
                                                    ({property.type})
                                                </li>
                                            ))}
                                        </ul>
                                    </Fragment>
                                )}
                            </AvailableProperties>
                            <div className="sidebar-divider" />
                            <AvailableActions>
                                {actions => (
                                    <Fragment>
                                        List of Available actions: ({actions.length})
                                        <br />
                                        <ul>
                                            {actions.map(action => (
                                                <li>
                                                    <DisplayBroadcast broadcast={action} />
                                                </li>
                                            ))}
                                        </ul>
                                    </Fragment>
                                )}
                            </AvailableActions>
                            <AvailableValidations>
                                {validations => (
                                    <Fragment>
                                        List of Available validations: ({validations.length})
                                        <br />
                                        <ul>
                                            {validations.map(item => (
                                                <li>
                                                    <DisplayBroadcast broadcast={item} />
                                                </li>
                                            ))}
                                        </ul>
                                    </Fragment>
                                )}
                            </AvailableValidations>
                            <div className="sidebar-divider" />
                            <b>styles</b>
                            <br />
                            <pre>{JSON.stringify(context.block.config.style, null, 4)}</pre>
                            <div className="sidebar-divider" />
                            <b>broadcast</b>
                            <br />
                            <pre>{JSON.stringify(context.block.config.broadcast, null, 4)}</pre>
                        </div>
                    )
                }
            </BlockContextConsumer>
        )

        return createPortal(children, document.getElementById("debug"))
    }
}

BlockDebugPortal.propTypes = {}

export default BlockDebugPortal



// WEBPACK FOOTER //
// ./src/features/editor/BlockDebugPortal.js